// ── SettlementDot 포맷 유틸 ────────────────────────────────────────────────────
import { toDateString } from '../../../utils/date';

/** 숫자를 한국어 3자리 콤마 형식으로 포맷 */
export function fmt(n) {
  return (Number(n) || 0).toLocaleString('ko-KR');
}

/** "YYYY-MM-DD..." 날짜 문자열을 "MM/DD" 형식으로 포맷 */
export function fmtDate(d) {
  if (!d) return '';
  const [, m, dd] = toDateString(d).split('-');
  return `${m}/${dd}`;
}

/**
 * contract_items 배열 → 주계약 표시 라벨 (예: "동반할인권×500 · 여행권×100")
 * @param {Array} contractItems - [{ticketTypeName, quantity, isService}]
 */
export function contractItemsLabel(contractItems) {
  const normal = (contractItems || []).filter((i) => !i.isService);
  return normal.map((i) => `${i.ticketTypeName || '?'}×${i.quantity}`).join(' · ') || '—';
}

/**
 * contract_items 배열 → 서비스 표시 라벨 (예: "서비스권×10")
 */
export function contractServiceLabel(contractItems) {
  const svc = (contractItems || []).filter((i) => i.isService);
  return svc.map((i) => `${i.ticketTypeName || '?'}×${i.quantity}`).join(' · ');
}
